module.exports = __webpack_public_path__ + "img/reporting_info_numbers.d06b1cf8.svg";